import { ucfirst } from "./ucfirst";
import { ucwords } from "./ucwords";

/**
 * Converts a given string to human-readable case.
 *
 * This function splits the input string into words based on camelCase, PascalCase,
 * snake_case, and other common delimiters, then joins them with spaces. Optionally,
 * it can capitalize the first letter of each word.
 *
 * @param value - The string to convert.
 * @param type - The type of capitalization to apply. If `true`, capitalizes the first
 * letter of each word. If `"ucfirst"`, capitalizes the first letter of the entire string.
 * If `"ucwords"`, capitalizes the first letter of each word. Defaults to `true`.
 * @returns The converted string.
 */
export const toHumanCase = (
  value: string,
  type: boolean | "ucfirst" | "ucwords" = true,
): string => {
  if (!value) return "";

  const matches = value.match(
    /\p{Lu}{2,}(?=\p{Lu}\p{Ll}|[0-9]|\b)|\p{Lu}?\p{Ll}+|\p{Lu}+(?!\p{Ll})|[0-9]+/gu,
  );

  if (matches) {
    const result = matches
      .map((x) => (x === x.toUpperCase() ? x : x.toLowerCase())) // Keep acronyms fully uppercase, lowercase others
      .join(" ");

    return type === true || type === "ucwords"
      ? ucwords(result)
      : type === "ucfirst"
        ? ucfirst(result)
        : result;
  }

  return "";
};
